import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {ErrorBoundary} from "react-error-boundary";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-quill/dist/quill.snow.css";
import {Provider} from "react-redux";

import {enableES5} from "immer";
import "nprogress/nprogress.css";

import App from "src/App";
import "src/assets/css/prism.css";
import {FlatformProvider} from "src/context/FlatformContext";
import {SettingsProvider} from "src/context/SettingsContext";
import "src/mixins/chartjs";
import "src/mixins/prismjs";
import "src/mock";
import * as serviceWorker from "src/serviceWorker";
import {configureStore} from "src/store";
import ErrorFallBack from "src/utils/errorBoundary";
import {restoreFlatform} from "src/utils/flatform";
import {restoreSettings} from "src/utils/settings";

enableES5();

const store = configureStore();
const settings = restoreSettings();
const storeFlatform = configureStore();
const flatform = restoreFlatform();

ReactDOM.render(
  <Provider store={store}>
    <Provider store={storeFlatform}>
      <SettingsProvider settings={settings}>
        <FlatformProvider flatform={flatform}>
          <ErrorBoundary FallbackComponent={ErrorFallBack}>
            <App />
          </ErrorBoundary>
        </FlatformProvider>
      </SettingsProvider>
    </Provider>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
